// french
const messages = {
};
module.exports = messages;
